/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Reasoning_Past_2Inputs */



/**
* | output |
* | --- |
* | "reasoned it through" |
*
* @param {Chat_Summary_Reasoning_Past_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_reasoning_past_2 = /** @type {((inputs?: Chat_Summary_Reasoning_Past_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Reasoning_Past_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("überlegt")
	return /** @type {LocalizedString} */ ("reasoned it through")
});